import React, { useContext, useEffect, useState } from 'react'
import { Container, Card, CardBody } from 'reactstrap'
import CurrencyFormat from 'react-currency-format'
import Moment from 'react-moment'
import toastr from 'toastr'

import Breadcrumbs from '../../components/Global/Breadcrumbs'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'
import RegistrarPagoModal from './components/RegistrarPagoModal'

const TH_STYLE = {
    padding: '8px 12px',
    fontWeight: 500,
    fontSize: 11,
    color: 'var(--color-text-secondary, #888)',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    borderBottom: '1px solid #e9ecef',
    whiteSpace: 'nowrap',
}

const TD_STYLE = {
    padding: '10px 12px',
    borderBottom: '0.5px solid #e9ecef',
    fontSize: 13,
}

const diasColor = (dias) => {
    if (dias > 60) return 'var(--color-text-danger, #E24B4A)'
    if (dias > 30) return 'var(--color-text-warning, #EF9F27)'
    return 'inherit'
}

const PorCobrar = () => {
    const { setLoading } = useContext(GeneralContext)
    const [facturas, setFacturas] = useState([])
    const [invoiceForPayment, setInvoiceForPayment] = useState(null)

    const loadInvoices = async () => {
        try {
            setLoading(true)
            const response = await ApiService.getFacturasPorCobrar()
            setFacturas(response.data?.data || [])
        } catch (error) {
            toastr.error('No pude cargar las facturas por cobrar.')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadInvoices()
        // eslint-disable-next-line
    }, [])

    const _download = async (uuid, type) => {
        try {
            await ApiService.downloadInvoice(uuid, type)
        } catch (err) {
            toastr.error('Error al descargar.')
        }
    }

    const now = new Date()

    return (
        <React.Fragment>
            <Container fluid>
                <Breadcrumbs
                    title="Facturas"
                    breadcrumbItem="Por cobrar"
                    parentLink="/facturas"
                />

                <Card>
                    <CardBody>
                        <div style={{ marginBottom: 16 }}>
                            <strong style={{ fontSize: 15 }}>Por cobrar</strong>
                            <div style={{ fontSize: 12, color: 'var(--color-text-secondary, #666)', marginTop: 2 }}>
                                Facturas pendientes de pago — ordenadas de más antiguas a más recientes
                            </div>
                        </div>

                        {facturas.length === 0 ? (
                            <p style={{ color: 'var(--color-text-secondary, #666)', fontSize: 13, margin: 0 }}>
                                No hay facturas pendientes de cobro.
                            </p>
                        ) : (
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...TH_STYLE, textAlign: 'left' }}>Receptor</th>
                                            <th style={{ ...TH_STYLE, textAlign: 'left' }}>Folio</th>
                                            <th style={{ ...TH_STYLE, textAlign: 'left' }}>Fecha</th>
                                            <th style={{ ...TH_STYLE, textAlign: 'right' }}>Días pendiente</th>
                                            <th style={{ ...TH_STYLE, textAlign: 'right' }}>Monto</th>
                                            <th style={{ ...TH_STYLE, textAlign: 'center' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {facturas.map((factura) => {
                                            const baseDate = factura.fechaTimbrado
                                                ? new Date(factura.fechaTimbrado)
                                                : new Date(factura.createdAt)
                                            const dias = Math.max(
                                                Math.floor((now.getTime() - baseDate.getTime()) / (1000 * 60 * 60 * 24)),
                                                0
                                            )
                                            const receptor = factura.clientes?.[0]?.razonSocial || 'Sin receptor'

                                            return (
                                                <tr key={factura._id}>
                                                    <td style={TD_STYLE}>{receptor}</td>
                                                    <td style={{ ...TD_STYLE, color: 'var(--color-text-secondary, #666)' }}>
                                                        {factura.folio ? `#${factura.folio}` : '—'}
                                                    </td>
                                                    <td style={{ ...TD_STYLE, color: 'var(--color-text-secondary, #666)', whiteSpace: 'nowrap' }}>
                                                        <Moment format="DD/MM/YYYY">{baseDate}</Moment>
                                                    </td>
                                                    <td style={{ ...TD_STYLE, textAlign: 'right', color: diasColor(dias), fontWeight: dias > 30 ? 500 : 400 }}>
                                                        {dias}d
                                                    </td>
                                                    <td style={{ ...TD_STYLE, textAlign: 'right', fontWeight: 500 }}>
                                                        <CurrencyFormat
                                                            value={parseFloat(factura.total) || 0}
                                                            displayType="text"
                                                            thousandSeparator
                                                            prefix="$"
                                                            decimalScale={2}
                                                        />
                                                    </td>
                                                    <td style={{ ...TD_STYLE, textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                        {factura.uuid && (
                                                            <>
                                                                <button
                                                                    style={{ background: 'none', border: 'none', color: '#378ADD', cursor: 'pointer', fontSize: 12, marginRight: 8, padding: 0 }}
                                                                    onClick={() => _download(factura.uuid, 'pdf')}
                                                                >
                                                                    PDF
                                                                </button>
                                                                <button
                                                                    style={{ background: 'none', border: 'none', color: '#378ADD', cursor: 'pointer', fontSize: 12, marginRight: 8, padding: 0 }}
                                                                    onClick={() => _download(factura.uuid, 'xml')}
                                                                >
                                                                    XML
                                                                </button>
                                                                {factura.tipoComprobante === 'I' && ['PUE', 'PPD'].includes(factura.metodoPago) && (
                                                                    <button
                                                                        style={{ background: 'none', border: 'none', color: '#1D9E75', cursor: 'pointer', fontSize: 12, padding: 0 }}
                                                                        onClick={() => setInvoiceForPayment(factura)}
                                                                    >
                                                                        Registrar pago
                                                                    </button>
                                                                )}
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </CardBody>
                </Card>
                {invoiceForPayment && (
                    <RegistrarPagoModal
                        invoice={invoiceForPayment}
                        isOpen={Boolean(invoiceForPayment)}
                        onRequestClose={() => setInvoiceForPayment(null)}
                        onSuccess={async () => {
                            setInvoiceForPayment(null)
                            await loadInvoices()
                        }}
                    />
                )}
            </Container>
        </React.Fragment>
    )
}

export default PorCobrar
